import { SupplierMobileViewPropsTypes } from "../SupplierMobileViewPropsTypes";
import MobileViewCompanyInfo from "../../MobileViewCompanyInfo";
import MobileViewSupplierInfo from "../../MobileViewSupplierInfo";
import NoteAndGuidance from "../../NoteAndGuidance";
import QuestionsMobileView from "../../QuestionsMobileView";
import { EnumSurveyAnswerStatus } from "../../Common/Enums/EnumsTypes";
import MobileSubmitView from "../../MobileSubmitView";
function SupplierMobileView({
  currentPage,
  handleNextPage,
  mobileViewPages,
  surveyAnswersInfo,
  monthsHash,
  setCurrentPage,
  reducerState,
  questionObjVariable,
  oldOption,
  dispatch,
  dependencyAnsHash,
  isPreview,
  checkNestedDependency,
  mainRefObject,
  setDependencyAnsHash,
  surveyAnswers,
  setSurveyAnswers,
  handleChangeAddComment,
  confirmDeleteFile,
  handleClearAnswer,
  clearValuesFromSurveyAnswers,
  SaveAsDraft,
  handleSubmitAnswers,
  params,
  removeAttachedFile,
  handleNoteComment,
}: SupplierMobileViewPropsTypes) {
  function renderComponent(componentName: string) {
    switch (componentName) {
      case "MobileViewCompanyInfo":
        return (
          <MobileViewCompanyInfo
            surveyAnswersInfo={surveyAnswersInfo}
            handleNextPage={handleNextPage}
          />
        );

      case "MobileViewSupplierInfo":
        return (
          <MobileViewSupplierInfo
            surveyAnswersInfo={surveyAnswersInfo}
            handleNextPage={handleNextPage}
            monthsHash={monthsHash}
          />
        );
      case "NoteAndGuidance":
        return (
          <NoteAndGuidance
            surveyAnswersInfo={surveyAnswersInfo}
            handleNextPage={handleNextPage}
          />
        );
      case "QuestionsMobileView":
        return (
          <QuestionsMobileView
            setCurrentPage={setCurrentPage}
            reducerState={reducerState}
            questionObjVariable={questionObjVariable}
            oldOption={oldOption}
            dispatch={dispatch}
            dependencyAnsHash={dependencyAnsHash}
            isPreview={isPreview}
            checkNestedDependency={checkNestedDependency}
            mainRefObject={mainRefObject}
            setDependencyAnsHash={setDependencyAnsHash}
            surveyAnswers={surveyAnswers}
            setSurveyAnswers={setSurveyAnswers}
            surveyAnswersInfo={surveyAnswersInfo}
            handleChangeAddComment={handleChangeAddComment}
            confirmDeleteFile={confirmDeleteFile}
            handleClearAnswer={handleClearAnswer}
            clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
            SaveAsDraft={SaveAsDraft}
            handleSubmitAnswers={handleSubmitAnswers}
            removeAttachedFile={removeAttachedFile}
            handleNoteComment={handleNoteComment}
          />
        );
    }
  }
  return (
    <>
      {surveyAnswersInfo?.surveyStatus !== EnumSurveyAnswerStatus.COMPLETED ? (
        Object.keys(surveyAnswersInfo).length > 0 &&
        renderComponent(mobileViewPages[currentPage]?.components)
      ) : (
        <MobileSubmitView
          reducerState={reducerState}
          questionObjVariable={questionObjVariable}
          surveyAnswers={surveyAnswers}
          setSurveyAnswers={setSurveyAnswers}
          mainRefObject={mainRefObject}
          checkNestedDependency={checkNestedDependency}
          isPreview={isPreview}
          dependencyAnsHash={dependencyAnsHash}
          setDependencyAnsHash={setDependencyAnsHash}
          clearValuesFromSurveyAnswers={clearValuesFromSurveyAnswers}
          dispatch={dispatch}
          surveyAnswersInfo={surveyAnswersInfo}
          oldOption={oldOption}
          handleNextPage={handleNextPage}
          monthsHash={monthsHash}
          params={params}
        />
      )}
    </>
  );
}

export default SupplierMobileView;
